// @ts-check
import axios from 'axios';
import config from '../constants/config';
import commonStrings from '../constants/commonStrings';

const binLookupAxios = axios.create();

/**
 *
 * @param {string} bin first 6 numbers of the card
 * @returns {Object}
 */
export const getBinLookup = (bin) => {
  const slicedBin = bin?.slice(0, 6) ?? '';
  return binLookupAxios
    .get(config.BIN_CHECKER_URL + `?format=json&api_key=${config.BIN_API_KEY}&bin=${slicedBin}`)
    .then(function (response) {
      if (response?.data) {
        let paymentType = response.data.type?.toLowerCase();
        if (response.data.type?.toUpperCase() === 'CHARGE CARD' || response.data.card === 'AMERICAN EXPRESS') {
          paymentType = commonStrings.credit;
        }
        return {
          cardNetwork: response?.data?.card,
          paymentType,
          binCodesResponse: response?.data,
        };
      }
    });
};
